<div class="h-screen flex items-center justify-center px-4" style="background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 50%, #d1fae5 100%);">
  <div style="width: 100%; max-width: 440px;">
    <div style="background: white; border-radius: 16px; box-shadow: 0 10px 40px rgba(0,0,0,0.08); overflow: hidden;">

      <!-- Logo -->
      <div style="text-align: center; padding: 32px 24px 0;">
        <img src="assets/img/LogoAW2025.png" alt="Aguacate Wallet"
          style="width: 52px; height: 52px; object-fit: contain; margin: 0 auto 12px;">
        <h2 style="font-size: 1.3rem; font-weight: 800; color: #1e5a3f; margin: 0 0 4px;">
          Nueva contraseña
        </h2>
        <p style="font-size: 0.85rem; color: #6b7280; margin: 0; line-height: 1.5;">
          Debe tener al menos 8 caracteres, contener mayusculas, minusculas, numeros y simbolos.
        </p>
      </div>

      <div style="padding: 24px;">
        <form [formGroup]="passwordForm" (ngSubmit)="onSubmit(passwordForm)">
          <!-- Password -->
          <div style="margin-bottom: 16px;">
            <label style="display: block; font-size: 0.8rem; font-weight: 600; color: #374151; margin-bottom: 6px;">
              Nueva contraseña
            </label>
            <div style="display: flex; align-items: center; gap: 10px; border: 1.5px solid #d1d5db; border-radius: 10px; padding: 10px 14px; background: #f9fafb; transition: border-color 0.2s ease;"
              [style.borderColor]="passwordForm.get('password')?.invalid && (passwordForm.get('password')?.dirty || passwordForm.get('password')?.touched) ? '#fca5a5' : '#d1d5db'">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #9ca3af; flex-shrink: 0;">lock</mat-icon>
              <input type="password" name="password" id="password" formControlName="password"
                placeholder="Ingresa tu nueva contraseña"
                style="flex: 1; border: none; outline: none; background: transparent; font-size: 0.88rem; color: #111827; padding: 0;">
            </div>
            <div *ngIf="passwordForm.get('password')?.invalid && (passwordForm.get('password')?.dirty || passwordForm.get('password')?.touched)"
              style="margin-top: 4px;">
              <span *ngIf="passwordForm.get('password')?.hasError('required')"
                style="font-size: 0.75rem; color: #dc2626; font-weight: 500;">
                Ingresa la contraseña
              </span>
              <div *ngIf="passwordForm.get('password')?.hasError('pattern')"
                style="margin-top: 4px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px; padding: 8px 12px;">
                <span style="font-size: 0.75rem; color: #991b1b; font-weight: 600;">La contraseña debe contener:</span>
                <ul style="margin: 4px 0 0; padding-left: 16px; font-size: 0.72rem; color: #991b1b; line-height: 1.6;">
                  <li>Minimo 8 caracteres</li>
                  <li>Minimo un numero</li>
                  <li>Minimo una letra mayuscula y una minuscula</li>
                  <li>Minimo un caracter especial ej: ^ $ * . [ ] {{'{ }' }} ( ) ? " ! "&#64;" # % & / \ , > < ' : ; | _ ~ ` = + -</li>
                </ul>
              </div>
            </div>
          </div>

          <!-- Confirm -->
          <div style="margin-bottom: 20px;">
            <label style="display: block; font-size: 0.8rem; font-weight: 600; color: #374151; margin-bottom: 6px;">
              Confirmar contraseña
            </label>
            <div style="display: flex; align-items: center; gap: 10px; border: 1.5px solid #d1d5db; border-radius: 10px; padding: 10px 14px; background: #f9fafb; transition: border-color 0.2s ease;"
              [style.borderColor]="passwordMatchError ? '#fca5a5' : '#d1d5db'">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #9ca3af; flex-shrink: 0;">lock_outline</mat-icon>
              <input type="password" name="passwordVerification" id="passwordVerification" formControlName="passwordVerification"
                placeholder="Confirma tu contraseña"
                style="flex: 1; border: none; outline: none; background: transparent; font-size: 0.88rem; color: #111827; padding: 0;">
            </div>
            <div *ngIf="passwordMatchError" style="margin-top: 4px;">
              <span style="font-size: 0.75rem; color: #dc2626; font-weight: 500;">Las contraseñas no coinciden</span>
            </div>
          </div>

          <!-- Error -->
          <div *ngIf="passwordResetError" style="margin-bottom: 16px;">
            <div style="display: flex; align-items: flex-start; gap: 8px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 10px; padding: 10px 14px;">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #dc2626; flex-shrink: 0; margin-top: 1px;">error</mat-icon>
              <span style="font-size: 0.82rem; font-weight: 600; color: #991b1b;">{{ passwordResetErrorMessage }}</span>
            </div>
          </div>

          <!-- Submit -->
          <button type="submit"
            [disabled]="passwordForm.invalid"
            [style.opacity]="passwordForm.invalid ? '0.5' : '1'"
            [style.cursor]="passwordForm.invalid ? 'not-allowed' : 'pointer'"
            style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 12px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.95rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="if(!this.disabled)this.style.background='#059669'" onmouseout="if(!this.disabled)this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">vpn_key</mat-icon>
            Reiniciar contraseña
          </button>
        </form>

        <div style="text-align: center; margin-top: 16px;">
          <a [routerLink]="['/auth/login']"
            style="font-size: 0.82rem; font-weight: 600; color: #1C593D; text-decoration: none; cursor: pointer;"
            onmouseover="this.style.color='#059669'" onmouseout="this.style.color='#1C593D'">
            Volver al inicio de sesion
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
